import React from 'react';
import WorkCard from './WorkCard';
import musicaliImage from '../../assets/musicali.png';
import quoteGenImage from '../../assets/quotegen.png';
import kontestifyImage from '../../assets/kontestify.png';
import keeperImage from '../../assets/keeper.png';
import emailAuthImage from '../../assets/emailauth.png';
import tindogImage from '../../assets/tindog.png';
import './WorkCards.css';

function WorkCards() {

  const workCardsData = [
    {
      src: tindogImage,
      title: 'Tindog',
      description: 'Landing page for a pet-centric company specializing in dog-related products and services',
      siteURL: 'https://tindog.shyamkhade.repl.co/',
      siteSourceCode: 'https://github.com/khadeshyam/TinDog'
    },
    {
      src: emailAuthImage,
      title: 'Email Authentication',
      description: 'Validates an email by sending OTP',
      siteURL: 'https://emailauthenticate.cyclic.app/',
      siteSourceCode: 'https://github.com/khadeshyam/Email-Authentication'
    },
    {
      src: keeperImage,
      title: 'Keeper App',
      description: 'A simple Notes taking web app',
      siteURL: 'https://keeper.shyamkhade.repl.co/',
      siteSourceCode: 'https://github.com/khadeshyam/keeper-app'
    },
    {
      src: musicaliImage,
      title: 'Musikali',
      description: 'A Music Player',
      siteURL: 'https://musically.shyamkhade.repl.co/',
      siteSourceCode: 'https://github.com/khadeshyam/Musically'
    },
    {
      src: quoteGenImage,
      title: 'Quote Generator',
      description: 'A random quote generator',
      siteURL: 'https://01quotegenerator.shyamkhade.repl.co/',
      siteSourceCode: 'https://replit.com/@ShyamKhade/01QuoteGenerator'
    },
    {
      src: kontestifyImage,
      title: 'Kontestify',
      description: 'Gets the details of upcoming coding contests',
      siteURL: 'https://kontestify.cyclic.app/',
      siteSourceCode: 'https://github.com/khadeshyam/Kontestify'
    }
  ];

  return (
    <div className='work-container'>
      <h1 className='project-heading'>Projects</h1>
      <div className='project-container'>
        {workCardsData.map((workCardData, index) => (
          <WorkCard
            key={index}
            src={workCardData.src}
            title={workCardData.title}
            description={workCardData.description}
            siteURL={workCardData.siteURL}
            siteSourceCode={workCardData.siteSourceCode}
          />
        ))}
      </div>
    </div>
  );
}

export default WorkCards;